import MicIcon from "@mui/icons-material/Mic";
import { styled } from "@mui/material";

export const StyledSpeechToText = {
  Container: styled("div")({
    height: 25,
  }),
  Mic: styled(MicIcon)(({ theme, disabled }) => ({
    position: "relative",
    marginTop: 3,
    cursor: disabled ? "default" : "pointer",
    marginLeft: -30,
    zIndex: 1,
    color: disabled ? "grey" : "black",
  })),
};
